<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1lghDF/Images/cover.jpg?1685327483780" alt="This image is the cover for the book Unto Us the Time Has Come, 2015 Advent Calendar - Sleigh Ride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unto Us the Time Has Come, 2015 Advent Calendar - Sleigh Ride
      </h1>
      <p class="bookDescription body article font2">
        <p>Last Christmas, Kenn Greyson gave husband Chris Martenson an ultimatum—spend more time with the family or we’re leaving. He never expected Chris’s reply would be “then leave,” but that’s exactly what happened, and Boxing Day took on a whole new meaning.</p> <p>Separated for nearly a year now, both men are miserable apart and coping the best they can for the kids’ sake. With Christmas just around the corner, a new conflict arises: neither man is willing to forego Christmas morning with their children. Chris finally suggests they spend the holiday together at the house and, to his shock, Kenn agrees.</p> <p>Armed with the knowledge that he’s been a stubborn idiot, but that perhaps he can change and begin to repair their relationship, Chris takes steps to win his husband back. He just hopes he can get Kenn on the same page before Santa comes down the chimney on Christmas Eve.</p><p><i>A story from the Dreamspinner Press 2015 Advent Calendar package "Sleigh Ride".</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean Michael
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?425b1274